import gs1Instance from '../api-index'

const { post } = gs1Instance

const registerUser = async payload => {
  const response = await post('/gs1/standard/user/register', payload)
  return response.data
}

const loginUser = async payload => {
  const response = await post('/gs1/standard/user/login', payload)
  return response.data
}

const forgotPassword = async email => {
  const response = await post('/gs1/standard/user/forgot-password', email)
  return response.data
}

const resetPassword = async payload => {
  const response = await post('/gs1/standard/user/reset-password', payload)
  return response.data
}

const setPassword = async payload => {
  const response = await post('/gs1/standard/user/set-password', payload)
  return response.data
}

const refreshAuth = async () => {
  const response = await post('/gs1/standard/user/refresh')
  return response.data
}

const logoutUser = async () => {
  const response = await post('/gs1/standard/user/logout', {})
  return response.data
}

export {
  registerUser,
  loginUser,
  forgotPassword,
  resetPassword,
  setPassword,
  refreshAuth,
  logoutUser
}
